import { parsePhoneNumber } from 'libphonenumber-js';

const parseToNational = (phone) => {
  if (!phone?.includes('+')) {
    return phone;
  }
  const paresPhone = parsePhoneNumber(phone)?.formatNational().split(' ');
  return paresPhone.join('');
};

export default parseToNational;
